import type { ReactElement } from 'react';
import type { ComplianceReportDto } from '@gr/core/distribution/channels/compliance';
import { useT } from '../../../../app/di';
import { Badge } from '../../../../ui-kit/Badge/Badge';
import { IssueList } from '../../../distribution/channels';
import styles from './ReadinessList.module.scss';

/** POST-UC-7: готовность поста к каждому каналу — длина подписи и замечания. */
export function ReadinessList({ reports }: { reports: readonly ComplianceReportDto[] }): ReactElement {
  const { t } = useT();
  return (
    <div className="u-stack" data-testid="readiness">
      {reports.map((report) => (
        <div key={report.channelId} className="u-stack u-gap-1">
          <div className={styles.head}>
            <strong className={styles.channel}>{report.channelName}</strong>
            <span className="u-muted u-small">{t('posts.readiness.caption', { n: report.captionLength })}</span>
          </div>
          {report.issues.length === 0 ? <Badge tone="success">{t('posts.readiness.ok')}</Badge> : <IssueList issues={report.issues} />}
        </div>
      ))}
    </div>
  );
}
